export interface SXMLTreeItemData{
    type: SXMLTypeEnum;
    name: string;
    attributes: SXMLAttributes[];
    content: string;
    children: SXMLTreeItemData[];
}
export enum SXMLTypeEnum{
    ELEMENT = 'Element',
    TEXT = 'Text',
    CDATA = 'CDATA',
    Comment = 'Comment',
    ProcessingInstruction = 'ProcessingInstruction',
    DocumentType = 'DocumentType'
}

export interface SXMLAttributes{
    [key: string]: string;
}
